import { endpointLogger, sensitiveEndpointLogger } from './clientLogger';
import { unsuccessfulStatus } from './httpStatus';

// todo: create a method fetchWrapper that both fetchAndLog and fetchAndLogSensitively calls?

export const STANDARD_API_ERROR_DETAIL = "Teknisk feil. ";

const STANDARD_API_ERROR_JSON = {
  status: 500,
  detail: STANDARD_API_ERROR_DETAIL,
};

const EXCEPTION_LOG_STATUS = "EXCEPTION";

/**
 * @param {Response} res
 */
async function parseResponse(res) {
  // this is how the old code expects it to be done ...

  if (res.status === 204) {
    // no data in response
    return {
      status: 204,
      detail: 'empty response',
    };
  }

  if (res.status === 500) {
    // currently backend API returns a string instead of JSON on 500 internal server errors
    return {
      status: 500,
      detail: STANDARD_API_ERROR_DETAIL,
      log: "internal server error - todo: handle this differently?",
    };
  }

  /** @type {unknown} */
  const data = await res.json();

  // FIX: added nullcheck for type inference
  if (typeof data !== "object" || !data) {
    // sometimes statusParsedResponse will be a string because
    // the API sometimes returns strings instead of JSONS
    return {
      status: res.status,
      detail: data,
    };
  }

  data.status = res.status;
  return data;
}

function addDetailIfMissing(responseData, status) {
  if (unsuccessfulStatus(status) && !responseData.detail) {
    responseData.detail = STANDARD_API_ERROR_DETAIL;
  }
  return responseData;
}

export async function fetchAndLog(endpoint, request) {
  return fetch(endpoint, request).then(parseResponse).then((response) => {
    if (response && unsuccessfulStatus(response.status)) {
      // log to backend
        
      endpointLogger(endpoint, request, response, response.status);
    }

    const responseDataWithDetail = addDetailIfMissing(response, response.status);

    if(response.status === 401) {
        console.log("should redirect to login from here")
        localStorage.removeItem("role");
        window.location.href = '/';
    }
    
    return responseDataWithDetail;
  }).catch((err) => {
    console.log(err);
    endpointLogger(endpoint, request, err, EXCEPTION_LOG_STATUS);

    return STANDARD_API_ERROR_JSON;
  });
}


// use this when the request has sensitive information like password
export async function fetchAndLogSensitively(endpoint, request) {
  return fetch(endpoint, request).then(parseResponse).then((response) => {
    if (response && unsuccessfulStatus(response.status)) {
      // log to backend
      sensitiveEndpointLogger(endpoint, response, response.status);
    }

    const responseDataWithDetail = addDetailIfMissing(response, response.status);

    return responseDataWithDetail;
  }).catch((err) => {
    console.log(err);
    return STANDARD_API_ERROR_JSON;
  });
}